/**
* @Author: zachalam
* @Date:   2017-02-07T15:43:50-08:00
* @Email:  zach@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-18T14:20:57-07:00
*/

import React, { Component, PropTypes } from 'react';
import { type, borders } from '../../style'
import { css, StyleSheet } from 'aphrodite/no-important';

const style = StyleSheet.create({
  textInput: {
    width: '100%',
    appearance: 'none',
    boxSizing: 'border-box',
    padding: '0 15px',
    height: '40px',
    outline: 'none',
    borderRadius: '3px',
    border: borders.DARKER,
    transition: 'border-color 0.2s ease-in-out',
    ...type.MD,

    ':focus': {
      border: borders.BRAND
    }
  },

  inline: {
    width: 'auto'
  },

  error: {
    borderColor: 'red !important'
  }
})


class TextInput extends Component {
  render() {

    let {
      error,
      ...rest
    } = this.props;


    return (
      <input {...rest} className={css(style.textInput, this.props.inline && style.inline, error && style.error)}
        autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" />
    );
  }
}

TextInput.propTypes = {
  onChange: PropTypes.any.isRequired,
  value: PropTypes.string,
  error: PropTypes.any,
  placeholder: PropTypes.any
};


export default TextInput;



// WEBPACK FOOTER //
// ./src/components/common/TextInput.jsx